import React from 'react';
import ReliabilityCTA from './ReliabilityCTA';
import product from './product';
import IntegrationFieldSupport from './IntegrationFieldSupport';
import Home from './home';
import ProjectExperience from './product';
import Technicalsupport from './technicalcapabilities';

const DefenceExpertise = () => {
  return (
    <div className="Defence-container">
      {/* <h1>Welcome to Combat Solutions</h1>
      <p>This is the Defence page of our application.</p> */}
      {/* Add more content as needed */}
      <Home />
      <ProjectExperience />
      <Technicalsupport />
      <IntegrationFieldSupport />
      <ReliabilityCTA />

    </div>
  );
};

export default DefenceExpertise;